import React from 'react'
import { useTranslation } from 'react-i18next'

import Form from '../../../../../components/Form'
import Field from '../../../../../components/Form/Field'
import FileUploadField from '../../../../../features/components/Form/FileUploadField'
import DatasetsSection from './DatasetsSection'

import { ICON, ICON_NAME, NAME } from './fields'

import useDrawerFormClasses from '../../../../../styles/common/drawerForms'

const PartnerAccountForm = ({ formik, isEditForm, ...formProps }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormClasses()

  return (
    <Form formik={formik} {...formProps}>
      <section className={drawerFormClasses.section}>
        <h3 className={drawerFormClasses.sectionTitle}>Partner name</h3>
        <p>The partner or sponsor’s brand name</p>
        <Field placeholder="Name of Partner" formik={formik} name={NAME} enableReinitialize autoComplete="off" />
      </section>

      <section className={drawerFormClasses.section}>
        <h3 className={drawerFormClasses.sectionTitle}>Upload an icon</h3>
        <p>
          {t(
            'Please upload an icon image for this partner. The best images have transparent backgrounds and have a 1:1 aspect ratio.'
          )}
        </p>
        <FileUploadField formik={formik} fileUrlField={ICON} fileNameField={ICON_NAME} />
      </section>

      {/*// We manage datasets in edit form only*/}
      {isEditForm && <DatasetsSection formik={formik} />}
    </Form>
  )
}

export default PartnerAccountForm
